import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IContract } from "@defs/contract";

interface ContractsState {
  loading: boolean;
  data: IContract[];
}

const initialState: ContractsState = {
  loading: true,
  data: [],
};

const contractsSlice = createSlice({
  name: "contracts",
  initialState,
  reducers: {},
  extraReducers: {
    "customer/contracts/pending": (state) => {
      state.loading = true;
      state.data = [];
    },
    "customer/contracts/fulfilled": (
      state,
      action: PayloadAction<IContract[]>
    ) => {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const contractActions = contractsSlice.actions;

export default contractsSlice.reducer;
